<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <ListaRegulamento />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import ListaRegulamento from "../Components/Listagens/ListaRegulamento.vue";
export default {
  name: "ListReserve",
  components: {
    ListaRegulamento,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>